import { VebinarItem } from './ui/VebinarItem.jsx'

export default VebinarItem
